// Manage project list
export interface IProjectList {
  id: string;
  seqId: number;
  name: string;
}

// Operation Types
export enum EOperationType {
  INDIVIDUAL = "INDIVIDUAL",
  INSTITUTION = "INSTITUTION",
}

// Allowed file size limits
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB
